import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const Pin = ({ x, y, info, id }) => {
  const [hover, setHover] = useState(false);
  const theme = useTheme();
  
  const handlePinClick = () => {
    // Łączymy "distributor-" z przekazanym numerem id (np. distributor-1)
    const targetId = `distributor-${id}`;
    const element = document.getElementById(targetId);
    
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      });
    }
  };
  
   return (
    <Box
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={handlePinClick} // Uruchomienie płynnego przewijania po kliknięciu
      sx={{
        position: 'absolute',
        top: y,
        left: x,
        transform: 'translate(-50%, -50%)',
        width: 15,
        height: 15,
        borderRadius: '50%',
        backgroundColor: theme.palette.primary.main,
        cursor: 'pointer',
        pointerEvents: 'auto', 
        zIndex: hover ? 100 : 1, 
        animation: 'pulse 1.5s infinite',
        '@keyframes pulse': {
          '0%': { boxShadow: `0 0 0 0 ${theme.palette.primary.main}70` },
          '70%': { boxShadow: `0 0 0 10px ${theme.palette.primary.main}00` },
          '100%': { boxShadow: `0 0 0 0 ${theme.palette.primary.main}00` },
        },
      }}
    >
      {hover && (
        <Box
          sx={{
            position: 'absolute',
            bottom: '150%', 
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: 'white',
            padding: '8px 14px', 
            borderRadius: '8px',
            boxShadow: theme.shadows,
            whiteSpace: 'nowrap', 
            textAlign: 'center',
            zIndex: 999, 
            '&::after': {
              content: '""',
              position: 'absolute',
              top: '100%', 
              left: '50%',
              transform: 'translateX(-50%)',
              borderWidth: '8px',
              borderStyle: 'solid',
              borderColor: 'white transparent transparent transparent',
            },
          }}
        >
          <Typography 
            variant="body2" 
            sx={{ 
              color: theme.palette.text.primary,
              fontWeight: 600, 
              fontSize: '0.8rem'
            }}
          >
            {info}
          </Typography>
        </Box>
      )}
    </Box>
  ); 
};

export default Pin;
